import { forwardRef } from 'react';

const variants = {
  ghost: 'bg-transparent text-[var(--color-warm-600)] hover:bg-[var(--color-cream-200)] hover:text-[var(--color-warm-900)]',
  subtle: 'bg-[var(--color-cream-200)] text-[var(--color-warm-700)] hover:bg-[var(--color-cream-300)] hover:text-[var(--color-warm-900)]',
  outlined: 'bg-[var(--color-cream-50)] text-[var(--color-warm-700)] border border-[var(--color-warm-200)] hover:bg-[var(--color-cream-200)]',
};

const sizes = {
  sm: 'w-8 h-8 rounded-[var(--radius-sm)] [&_svg]:w-4 [&_svg]:h-4',
  md: 'w-10 h-10 rounded-[var(--radius-md)] [&_svg]:w-5 [&_svg]:h-5',
  lg: 'w-12 h-12 rounded-[var(--radius-md)] [&_svg]:w-6 [&_svg]:h-6',
};

const IconButton = forwardRef(function IconButton(
  { variant = 'ghost', size = 'md', className = '', label, children, ...props },
  ref
) {
  return (
    <button
      ref={ref}
      aria-label={label}
      title={label}
      className={`
        inline-flex items-center justify-center
        transition-all duration-150 ease-out
        disabled:opacity-50 disabled:cursor-not-allowed
        ${variants[variant]} ${sizes[size]} ${className}
      `}
      {...props}
    >
      {children}
    </button>
  );
});

export default IconButton;
